import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import Swal from "sweetalert2";

import {
  getBillerTAndCByType,
  addBillerTAndC,
  updateBillerTAndC,
} from "./termsAndConditionsApi";

const TermsAndConditions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedUIType, setSelectedUIType] = useState("");
  const [selectedAPIType, setSelectedAPIType] = useState("");
  const [tAndCData, setTAndCData] = useState({});

  const tabs = [
    {
      label: "Terms and Conditions for Purchase Order",
      value: "TCPurchaseOrder",
      apiValue: "Purchase",
    },
    {
      label: "Terms and Conditions for Quotations",
      value: "TCQuotation",
      apiValue: "Quotation",
    },
  ];

  const openModal = async (tab) => {
    setSelectedTab(tab.value);
    setSelectedUIType(tab.label);
    setSelectedAPIType(tab.apiValue);
    setModalOpen(true);

    try {
      const res = await getBillerTAndCByType(tab.apiValue);
      if (res?.data?.succeeded) {
        setTAndCData((prev) => ({
          ...prev,
          [tab.value]: res.data.data,
        }));
      }
    } catch (err) {
      console.error("Fetch T&C error:", err);
    }
  };

  const handleSave = async (details) => {
    const existing = tAndCData[selectedTab];
    const type = selectedAPIType;

    try {
      if (existing?.id) {
        await updateBillerTAndC({ ...existing, details });
        Swal.fire({
          toast: "true",
          position: "top-end",
          icon: "success",
          text: "Terms and conditions updated successfully",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        await addBillerTAndC({ Type: type, details });
        Swal.fire({
          toast: "true",
          position: "top-end",
          icon: "success",
          text: "Terms and conditions added successfully",
          timer: 3000,
          showConfirmButton: false,
        });
      }

      const res = await getBillerTAndCByType(type);
      if (res?.data?.succeeded) {
        setTAndCData((prev) => ({
          ...prev,
          [selectedTab]: res.data.data,
        }));
      }

      setModalOpen(false);
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  return (
    <Box sx={{ background: "#ede9ff", minHeight: "100vh", p: 3 }}>
      <Grid container spacing={2} justifyContent="center" sx={{ mb: 3 }}>
        {tabs.map((tab, index) => (
          <Grid item xs={12} md={5} sm={6} key={index}>
            <Box
              sx={{
                height: 50,
                backgroundColor: "#01008B",
                borderRadius: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 1,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                px:2,
                fontWeight: 600,
                color: "#fff",
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
              }}
              onClick={() => openModal(tab)}
            >
              {tab.label}
            </Box>
          </Grid>
        ))}
      </Grid>

      <TermsAndConditionsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        type={selectedUIType}
        data={tAndCData[selectedTab]}
        onSave={handleSave}
      />
    </Box>
  );
};

export default TermsAndConditions;
